import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconUnlink = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M17.834 11.469l1.325-1.326a3.963 3.963 0 00.266-5.568v0a3.962 3.962 0 00-5.568.265L12.53 6.166M11.47 17.833l-1.326 1.326a3.963 3.963 0 01-5.568.265v0a3.963 3.963 0 01.265-5.568l1.326-1.326M7.227 7.226L4.045 4.044M5.106 9.347H2.984M9.348 5.105V2.983M16.773 16.772l3.182 3.182M14.652 18.893v2.122M18.894 14.65h2.122",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconUnlink.displayName = "IconUnlink";

export { IconUnlink };
